import React from 'react';

/**
 * @param {{ items: Array<{ code?: string, message?: string, tone?: 'default'|'soft' }> }} props
 */
export default function AdminWarningList({ items }) {
  if (!items?.length) return null;
  return (
    <ul className="admin-hub-kit-warnings">
      {items.map((it, i) => (
        <li
          key={`${it.code || 'w'}-${i}`}
          className={it.tone === 'soft' ? 'admin-hub-kit-warnings__item--soft' : ''}
        >
          {it.code ? <span className="admin-hub-kit-warnings__code">{it.code}</span> : null}
          <span>{it.message || ''}</span>
        </li>
      ))}
    </ul>
  );
}
